var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52.802,
    height: 52.802,
    viewBox: "0 0 52.802 52.802",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_34",
    "data-name": "Layer 34"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M34.4,8A26.4,26.4,0,1,0,60.8,34.4,26.4,26.4,0,0,0,34.4,8ZM52.189,27.691V45.028a.638.638,0,0,1-.33.572.649.649,0,0,1-.594,0L45.677,40.55V32.135l5.588-5.049a.649.649,0,0,1,.594,0,.638.638,0,0,1,.33.605ZM38.68,47.041H21.4a4.785,4.785,0,0,1-4.785-4.785V30.474a4.8,4.8,0,0,1,4.785-4.8h3.366a5.005,5.005,0,0,0,9.768,0H38.68a4.8,4.8,0,0,1,4.8,4.8V42.255a4.8,4.8,0,0,1-4.8,4.785Zm-9.031-25.3a2.805,2.805,0,1,0,0,.022Z",
    transform: "translate(-8 -8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.7b61596813a451813562cbec9a8c2fb7.svg";
export { ForwardRef as ReactComponent };